import { useConnectionState, useRoomContext } from '@livekit/components-react';
import { useLeaveRoom } from '@queries/rooms';
import { ConnectionState } from 'livekit-client';

export default function useDisconnectOrLeaveRoom() {
  const livekitRoom = useRoomContext();
  const connectionState = useConnectionState();
  const { mutate: leaveRoom } = useLeaveRoom();

  return async () => {
    if (connectionState === ConnectionState.Disconnected) leaveRoom();
    else await livekitRoom.disconnect(true);
  };
}
